export const FULL_PAGE_BACKGROUND_VIDEOS = "background-videos";
export const FULL_HEIGHT_VIDEOS = "full-height-videos";
export const PARAGRAPH_AND_ASSET_VIDEOS = "paragraph-and-asset-videos";
